import styled from '@emotion/styled';
import { SLAPerformance } from 'api/resources/models/AutoGenerated';

export function GroupCellContent(
  reportData: SLAPerformance[] | undefined,
  props: any,
) {
  const { column, value } = props;
    if (column.dataField === 'slaTitle') {
    return (
      <span>
        <StrongText>{value}</StrongText>
        <CustomText>
          {reportData?.find((a) => a.slaTitle === value)?.slaDescription}
        </CustomText>
      </span>
    );
  }
  return value;
}

const StrongText = styled(`strong`)`
  color: black;
  font-weight: 600;
`;

const CustomText = styled(`p`)`
  font-style: italic;
  margin-left: 20px;
  white-space: pre-wrap;
  margin-top: 0;
  margin-bottom: 0;
`;
